import { useState } from "react";
import Sidebar from "./Sidebar";
import Topbar from "./Topbar";
import { Sheet, SheetContent } from "@/components/ui/sheet";

export default function AppShell({ children }) {
  const [navOpen, setNavOpen] = useState(false);

  return (
    <div className="min-h-screen bg-background text-foreground">
      <Sidebar className="hidden md:flex" />
      <Sheet open={navOpen} onOpenChange={setNavOpen}>
        <SheetContent side="left" className="w-72 max-w-[85vw] border-border p-0">
          <Sidebar mobile onNavigate={() => setNavOpen(false)} className="relative flex h-full w-full border-r-0" />
        </SheetContent>
      </Sheet>
      <Topbar onMenuClick={() => setNavOpen(true)} />
      <main className="pt-14 md:pl-64">
        <div className="mx-auto max-w-[1600px] p-4 sm:p-6 lg:p-8">{children}</div>
      </main>
    </div>
  );
}
